import type { ComponentProps } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';

import { cn, POPOVER_MOTION } from '../lib/cn';

// The one place `@radix-ui/react-popover` is imported: a feature reaching for the raw
// primitive again means this panel styling drifted from theirs without anyone deciding to.
export const Popover = RadixPopover.Root;
export const PopoverTrigger = RadixPopover.Trigger;
export const PopoverAnchor = RadixPopover.Anchor;

export const PopoverContent = ({
  className,
  children,
  ...rest
}: ComponentProps<typeof RadixPopover.Content>) => (
  <RadixPopover.Portal>
    <RadixPopover.Content
      side="bottom"
      align="start"
      sideOffset={6}
      collisionPadding={8}
      className={cn(
        'flex flex-col overflow-hidden rounded-float border border-node-line bg-surface-raised shadow-panel',
        POPOVER_MOTION,
        className,
      )}
      {...rest}
    >
      {children}
    </RadixPopover.Content>
  </RadixPopover.Portal>
);
